import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

const CustomSelect = ({
  label,
  value = "",
  fullWidth = true,
  onChange,
  options,
  optionsValueKey = "id",
  optionsLabelKey = "name",
  error = false,
  helperText = "",
  showHelperText = false,
}: any) => {
  return (
    <FormControl
      sx={{ minWidth: 120 }}
      size="medium"
      fullWidth={fullWidth}
      error={error}
      
    >
      <InputLabel sx={{color: "#c2c2c2", }}>{label}</InputLabel>
      <Select
        sx={{
          // height: "56px",
          ".MuiSvgIcon-root ": {
            fill: "#000 !important",
          },
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: "#dfdfdf",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#dfdfdf",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#dfdfdf",
          },
        }}
        value={value}
        defaultValue={""}
        label={label}
        onChange={onChange}
        // required
      >
        {options.map((y: any) => (
          <MenuItem key={y[optionsValueKey]} value={y[optionsValueKey]}>
            {y[optionsLabelKey]}
          </MenuItem>
        ))}
      </Select>
      {showHelperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default CustomSelect;
